import styled from 'styled-components';

export const TaskCardStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: flex-start;

  & .role {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  & .tasks {
    display: flex;
    flex-direction: column;
    gap: 20px;

    & .task-desc {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
  }

  & .details {
    display: flex;
    flex-direction: column;
    gap: 20px;

    & .desc {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
  }
`;
